module.exports = __webpack_public_path__ + "media/packs/images/state/small/document-ea3a76123fe2deff8991732885dff9fe.svg";